module.exports = __webpack_public_path__ + "static/img/turbine.29ca881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/intro/turbine.svg
// module id = 24
// module chunks = 2